/**
 * Brand settings: the single place to change when the CoolTesters visual identity
 * is ready. Used by the PDF renderer, the emails and the web (which turns the
 * colors into CSS variables at startup). Pure data, no imports.
 */
export const BRAND = {
  name: "CoolTesters",
  productName: "CoolTesters Business",
  legalName: "Aurean Blue Servicios Empresariales S de RL de CV",
  website: "cooltesters.com",
  email: "contacto@cooltesters.com",
  phone: "+52 81 3078 8589",
  colors: {
    primary: "#1f3a5f",
    primaryContrast: "#ffffff",
    accent: "#2e86de",
    text: "#1b1f24",
    muted: "#5f6b7a",
    border: "#dfe3e8",
  },
} as const;

export type Brand = typeof BRAND;
